module.exports = __webpack_public_path__ + "media/music/ed2a96fbdb476efe419246982e357121.mp3";